const PIXEL_ID = '1030509502846499'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const w = window as any
  const d = document

  /* Standard Meta Pixel bootstrap */
  if (w.fbq) return
  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = d.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = d.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    d.head.appendChild(t)
  }

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackPixelEvent(event: string, data?: Record<string, any>) {
  if (typeof window === 'undefined') return
  const w = window as any
  if (typeof w.fbq !== 'function') return
  w.fbq('track', event, data)
}
